<template>
	<v-sheet elevation="0">
		<CommonFlame :title="title" class="ma-2">
			<template v-slot:app-bar-btn>
				<v-btn color="primary" @click="showUnassignedOrders = !showUnassignedOrders"
					>未割振製造オーダートレー</v-btn
				>
			</template>

			<v-main>
				<v-container v-if="showTrashCan" fluid>
					<v-row>
						<v-col cols="12">
							<v-card @dragover.prevent @drop="onDropToTrash">
								<v-card-text>ここにドロップしてチームから製品オーダーを削除</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-container>

				<v-container fluid>
					<v-row>
						<v-col v-for="(team, index) in teams" :key="index" cols="12" md="6" lg="4">
							<v-card @dragover.prevent @drop="onDropToTeam(team)">
								<v-card-title>{{ team.name }}</v-card-title>
								<v-card-text>
									<v-list dense>
										<v-list-item
											v-for="(order, i) in team.return_current_orders_full_info"
											:key="index + '-' + i"
											class="pa-1"
										>
											<v-card
												draggable
												@dragstart="onDragStartFromTeam(order, index, i)"
												class="grab"
											>
												<v-card-text class="pa-1"
													>製造番号：{{ order.ordered_product.product_number }}-{{
														order.sub_number
													}}</v-card-text
												>
												<v-card-title class="text-subtitle-2 pa-1"
													>{{ order.ordered_product.product.name }}
													{{ order.ordered_product.sub_name }}</v-card-title
												>
												<v-card-text class="pa-1"
													>数量：{{ order.quantity }}{{ " " }}出荷日：{{
														order.delivery_info.shipping_date
															? common.formatDateWithDay(order.delivery_info.shipping_date)
															: "未設定"
													}}</v-card-text
												>
											</v-card>
										</v-list-item>
									</v-list>
								</v-card-text>
								<!-- <v-card-actions>
									<v-btn color="primary" @click="showUnassignedOrders = !showUnassignedOrders"
										>製品を追加</v-btn
									>
									<v-spacer></v-spacer>
									<v-btn color="error" @click="deleteTeam(team)">削除</v-btn>
								</v-card-actions> -->
							</v-card>
						</v-col>
					</v-row>
				</v-container>

				<v-container v-if="showUnassignedOrders" fluid>
					<v-row style="background-color: #f2f2f2">
						<v-col v-for="(order, index) in unassignedOrders" :key="index" cols="12" md="4" lg="3">
							<v-card draggable @dragstart="onDragStart(order, index)" class="grab">
								<v-card-text class="pa-1"
									>製造番号：{{ order.ordered_product.product_number }}-{{
										order.sub_number
									}}</v-card-text
								>
								<v-card-title class="text-subtitle-2 pa-1"
									>{{ order.ordered_product.product.name }}
									{{ order.ordered_product.sub_name }}</v-card-title
								>
								<v-card-text class="pa-1"
									>数量：{{ order.quantity }}{{ " " }}出荷日：{{
										order.delivery_info.shipping_date
											? common.formatDateWithDay(order.delivery_info.shipping_date)
											: "未設定"
									}}</v-card-text
								>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</v-main>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		CommonFlame,
	},
	data() {
		return {
			common: common,
			title: "チームへ割振",
			teams: [],
			unassignedOrders: [],
			showUnassignedOrders: false,
			showTrashCan: false,
			draggingOrder: null,
			teamToTeam: false,
			fromTeamIndex: null,
			formTeamOrderIndex: null,
			trayToTeam: false,
			fromTrayIndex: null,
		}
	},
	mounted() {
		this.getTeams()
	},
	methods: {
		getTeams() {
			axios
				.get("/erp/v1/order_allocations/to_teams", { headers: authenticate.setHeader() })
				.then((response) => {
					this.teams = response.data.teams
					console.log(this.teams)
				})
				.catch((error) => {
					console.log(error)
				})
		},
		deleteTeam(team) {
			axios
				.delete(`/api/teams/${team.id}`, { headers: authenticate.setHeader() })
				.then((response) => {
					this.teams = this.teams.filter((t) => t.id !== team.id)
				})
				.catch((error) => {
					console.log(error)
				})
		},
		onDragStart(order) {
			this.draggingOrder = order
			this.showTrashCan = true
			this.trayToTeam = true
		},
		onDragStartFromTeam(order, teamIndex, orderIndex) {
			this.draggingOrder = order
			this.showTrashCan = true
			this.teamToTeam = true
			this.fromTeamIndex = teamIndex
			this.formTeamOrderIndex = orderIndex
		},
		onDropToTeam(team) {
			if (
				team.return_current_orders_full_info.findIndex(
					(order) => order.id === this.draggingOrder.id
				) === -1
			) {
				console.log("!")
				const headers = authenticate.setHeader()
				axios
					.post(
						"/erp/v1/order_allocations/to_teams",
						{
							order_individual_info_id: this.draggingOrder.id,
							team_id: team.id,
						},
						{ headers }
					)
					.then((response) => {
						// 成功時の処理
						team.return_current_orders_full_info.push(this.draggingOrder)
						this.draggingOrder = null
						this.$store.commit("setFlash", {
							text: response.data.message,
							type: "notice",
						})
						// チーム間のドラッグアンドドロップの場合
						if (this.teamToTeam == true) {
							this.teams[this.fromTeamIndex].return_current_orders_full_info.splice(
								[this.formTeamOrderIndex],
								1
							)
							this.teamToTeam = false
							this.fromTeamIndex = null
							this.formTeamOrderIndex = null
						}
						// トレイからチームへのドラッグアンドドロップの場合
						if (this.trayToTeam) {
							this.unassignedOrders.splice(this.fromTrayIndex, 1)
							this.trayToTeam = false
							this.fromTrayIndex = null
						}
					})
					.catch((error) => {
						this.draggingOrder = null
						console.error(error)
						errorHandling.errorResponse(err)
						this.teamToTeam = false
						this.fromTeamIndex = null
						this.formTeamOrderIndex = null
						this.trayToTeam = false
						this.fromTrayIndex = null
					})
			}
		},
		onDropToTrash() {
			if (this.teamToTeam) {
				const headers = authenticate.setHeader()
				axios
					.delete("/erp/v1/order_allocations/to_teams/" + this.draggingOrder.id, {
						params: {
							order_individual_info_id: this.draggingOrder.id,
							team_id: this.teams[this.fromTeamIndex].id,
						},
						headers,
					})
					.then((response) => {
						this.$store.commit("setFlash", {
							text: response.data.message,
							type: "notice",
						})
						this.teams[this.fromTeamIndex].return_current_orders_full_info.splice(
							[this.formTeamOrderIndex],
							1
						)
						this.teamToTeam = false
						this.fromTeamIndex = null
						this.formTeamOrderIndex = null
					})
					.catch((error) => {
						console.error(error)
						errorHandling.errorResponse(err)
					})
			}
		},
		getUnassignedOrders() {
			axios
				.get("/erp/v1/order_allocations/unassigned_orders", { headers: authenticate.setHeader() })
				.then((response) => {
					this.unassignedOrders = response.data.orders
					console.log(this.unassignedOrders)
				})
				.catch((error) => {
					console.log(error)
				})
		},
	},
	watch: {
		showUnassignedOrders(newVal) {
			if (newVal) {
				this.getUnassignedOrders()
			}
		},
	},
}
</script>
<style lang="scss">
.grab {
	cursor: grab;
	&:active {
		cursor: grabbing;
	}
}
</style>
